import ageonLogo from "../assets/logo/ageon.png";
import ageonLogoWhite from "../assets/logo/ageon_white.png";
import ebgLogo from "../assets/logo/ebg.svg";
import logo1 from "../assets/logo/1.svg";
import logo2 from "../assets/logo/2.svg";
import logo3 from "../assets/logo/3.svg";
import logo4 from "../assets/logo/4.svg";
import logo5 from "../assets/logo/5.svg";
import logo6 from "../assets/logo/6.svg";
import logo7 from "../assets/logo/7.svg";
import logo8 from "../assets/logo/8.svg";
import logo9 from "../assets/logo/9.svg";

import therapyHydrogen from "../assets/therapies/hydrogen.webp";
import therapyRedLight from "../assets/therapies/red-light.webp";
import therapyHyperbaric from "../assets/therapies/hyperbaric.webp";
import therapyInfrared from "../assets/therapies/infrared.webp";
import therapyPemf from "../assets/therapies/PEMF.webp";
import therapyArctic from "../assets/therapies/arctic.webp";
import therapyIv from "../assets/therapies/iv-therapy.webp";
import therapyEms from "../assets/therapies/EMS.webp";

export {
  ageonLogo,
  ageonLogoWhite,
  ebgLogo,
  logo1,
  logo2,
  logo3,
  logo4,
  logo5,
  logo6,
  logo7,
  logo8,
  logo9,
};

/** Landing “Eight pillars” — keys match `THERAPIES[].imageKey` in `landing/landingData.js` */
export const therapyImages = {
  hydrogen: therapyHydrogen,
  redLight: therapyRedLight,
  hyperbaric: therapyHyperbaric,
  infrared: therapyInfrared,
  pemf: therapyPemf,
  arctic: therapyArctic,
  iv: therapyIv,
  ems: therapyEms,
};
